import React from 'react';
import cls from './page404.module.scss'
import { Link } from 'react-router-dom';
import HelmetComponent from '../../components/HelmetComponent';
import { useTranslation } from 'react-i18next';

const Page404 = () => {
    const { t } = useTranslation();
    return (
        <div className={cls.page404_container}>
            <HelmetComponent titlePage={t('helmet.404.title')} description={t('helmet.404.description')} title={t('helmet.404.title')} keywords={t('helmet.404.keywords')} />
            <div className={cls.page404_code_and_message_wrapper}>
                <div className={cls.page404_code}>
                    404
        </div>
                <div className={cls.page404_message}>
                    Not Found
        </div>
            </div>
            <div className={cls.page404_link}>
                <Link to='/'>{t('pages.404.h2')}</Link>
            </div>
        </div>
    )
}

export default Page404;